import { render, staticRenderFns } from "./StackContent.vue?vue&type=template&id=4f7d0d05&scoped=true"
import script from "./StackContent.vue?vue&type=script&lang=js"
export * from "./StackContent.vue?vue&type=script&lang=js"
import style0 from "./StackContent.vue?vue&type=style&index=0&id=4f7d0d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d0d05",
  null
  
)

export default component.exports